import { LanguageMap } from "@/assets/languages/language";

export const en: LanguageMap = {
  enterId: "Enter ID",
  rotationList: "Rotation list",
  headJudgeCalledMeeting: "Head Judge has called a meeting",
  pointsAcceptedByHeadJudge: "Points accepted by head judge",
  waitingHeadJudgeAcceptance: "Waiting for head judge acceptance",
  moveToNextParticipant: "Points accepted. Move to the next participant?",
  penaltyAndBonus: "Penalty and bonus",
  resultsOfTheCompetition: "Wait for the results of the competition",
  confirmPenaltyAndBonus: "Confirm penalty and bonus",
  confirmPenalty: "Confirm penalty",
  confirmBonus: "Confirm bonus",
  current: "Current",
  next: "Next",
  total: "Total",
  authInformation: "You have logged in as",
  competition: "Competition",
  date: "Date",
  numpad: "Numpad",
  noPenalty: "No penalty",
  value: "Value",
  ratingMultipleInputs: {
    selectCellToEnter: "Select a cell to enter a score",
    selectCellToView: "Select a cell to see its criterion",
    labelWithMax: "{label} (max {max})",
  },
  elements: "ELEMENTS",
  searchPlaceholder: "Search...",
  buttons: {
    logIn: "Log in",
    cancel: "Cancel",
    done: "Done",
    send: "Send",
    back: "Back",
    callMeeting: "Call a meeting",
    bonus: "Bonus",
    penalty: "Penalty",
    confirm: "Confirm",
    confirmSending: "Confirm sending",
    confirmSendingFeedback: "Confirm sending feedback",
    changeOwnPoints: "Change own points",
    logOut: "Log out",
    yes: "Yes",
    no: "No",
    ok: "OK",
    saveOwnPoints: "Save own points",
    continue: "Continue",
    hideAddInteface: "Show less options",
    showAddInteface: "Show more options",
    saveDraft: "Save draft",
    select: "Select",
  },
  error: {
    incorrectCode: "Incorrect code",
    warningTitle: "Warning",
    networkError: "Check network connection",
  },
  agg_tv_element_group: {
    combined_series: "Combined Series",
    combined_series_short: "Combined Series",
    balances: "Balances",
    jumps: "Jumps",
    total_bm: "Total BM",
    tbm: "Total BM",
    bms: "BMS",
    dance_step_series: "Dance Step Series",
    step_series: "Step Series",
    acrobatics: "Acrobatics",
    flexibility: "Flexibility",
    bilaterality: "Flexibility movements 135°",
    bilaterality_adults: "Bilaterality",
    body_series: "3 highest body series",
  },
  agg_avb_element_group: {
    bilaterality: "Bilaterality",
    bms_criteria: "BMS Criteria",
    additional_allowances: "Additional Allowances",
    collaboration_elements: "Collaboration Elements",
    originality: "Originality",
  },
  agg_avb_element: {
    bilaterality_balance_right: "Balance – right",
    bilaterality_balance_left: "Balance – left",
    bilaterality_jump_right: "Jump – right",
    bilaterality_jump_left: "Jump – left",
    bms_turning: "Change of direction, turn/rotation",
    bms_level_change: "Change of level",
    bms_travelling: "Travelling",
    bms_tempo: "Change of tempo",
    bms_dynamics: "Change of dynamics",
    additional_body_balance: "Balance started directly from a body movement",
    additional_body_jump: "Jump started directly from a body movement",
    additional_rotating_balance: "Rotating balance (pivot / illusion)",
    additional_rotating_jump: "Rotating / turning jump",
    collaboration_team_collaboration: "Collaboration without lift",
    collaboration_duo_trio_collaboration: "Duo/trio collaboration with or without lift",
    collaboration_team_lift: "Collaboration with lift",
    collaboration_sync_element: "Synchronized movement series",
    collaboration_canon: "Canon",
    originality_movement: "Originality of movements",
    originality_collaboration: "Originality of collaborations and formations",
    originality_music: "Unforgettable connection between music and choreography",
    originality_story: "Thematic story/style",
  },
  feedback: {
    title: "Feedback",
    draftSaved: "Draft saved",
    submitReminder: "Remember to submit your feedback with Send-button when you are ready",
    feedbackNotSubmitted: "Feedback not submitted",
    field: {
      overallImpression: "Overall impression",
      gymnastGreetings: "Feedback to gymnasts",
      coachGreetings: "Feedback to coaches",
    },
  },
  penalty: {
    forbidden_move: "Forbidden movement or lift",
    offence: "Religious/political insults",
    insult: "Religious/political insults",
    coming_in: "Team entrance",
    entrance: "Team entrance",
    dress: "Dress, hair or make-up",
    decoration: "Color spot on the competition area caused by hair dye",
    time: "Additional or missing seconds",
    wrong_apparatus: "Non-standard apparatus",
    lost_items: "Lost items",
    too_few_members: "Missing gymnast",
    reserved_apparatus: "Use of a replacement apparatus",
    too_many_apparatus: "Using any apparatus not previously placed",
    replacement_apparatus_assistance: "Assistance in using of a replacement apparatus",
    assistance: "Assistance by any official person",
    border: "Borderline crossing",
    extra_sound: "Extra sound",
    team_assistance: "Team assistance",
    athlete_or_coach_behavior: "Athlete or coach behavior",
  },
  agg_tv_element: {
    combined_series_bms_balance: "BMS + balance",
    combined_series_bms_jump: "BMS + jump",
    combined_series_balance_bms: "Balance + BMS",
    combined_series_bbms_or_bmsb: "Balance + BMS / BMS + balance",
    combined_series_jump_bms: "Jump + BMS",
    combined_series_jbms_or_bmsj: "Jump + BMS / BMS + jump",
    combined_series_jump_balance: "Jump + balance",
    combined_series_jb_or_bj: "Jump + balance / balance + jump",
    combined_series_balance_jump: "Balance + jump",
    combined_series_jump_balance_bms:
      "Jump/balance + body movements or body movements + jump/balance",
    balances_double_balance: "2 balances",
    balances_single_balance: "1 balance",
    balances_balance: "Balance",
    balances_dyn_balance: "Dynamic balance",
    balances_balance_series: "Balance series",
    jumps_double_jump: "2 jumps",
    jumps_single_jump: "1 jump",
    jumps_jump: "Jump",
    jumps_rotation_jump: "Turning/rotating jump",
    jumps_jump_series: "Jump series",
    bms_bms1: "BMS 1",
    bms_bms_1: "BMS 1",
    bms_bms2: "BMS 2",
    bms_bms_2: "BMS 2",
    bms_bms3: "BMS 3",
    bms_bms_3: "BMS 3",
    bms_bms4: "BMS 4",
    bms_bms_4: "BMS 4",
    bms_bms5: "BMS 5",
    tbm_wave1: "Body wave 1",
    tbm_wave_1: "Body wave 1",
    tbm_wave2: "Body wave 2",
    tbm_wave_2: "Body wave 2",
    tbm_swing1: "Body swing 1",
    tbm_swing_1: "Body swing 1",
    tbm_swing2: "Body swing 2",
    tbm_swing_2: "Body swing 2",
    total_bm_wave: "Wave",
    total_bm_swing: "Swing",
    total_bm_twisting: "Twist",
    total_bm_contraction: "Contraction",
    total_bm_relaxation: "Relaxation",
    total_bm_lunge_lean: "Lunge or lean",
    total_bm_series_a: "A body movement series",
    total_bm_series_b: "B body movement series",
    total_bm_series_c: "C body movement series",
    total_bm_total_wave: "Total wave",
    total_bm_total_swing: "Total swing",
    dance_step_series_combined: "Step series combined with another movement family",
    dance_step_series_dss_1: "Step series including change of direction and a turn",
    dance_step_series_dss_2:
      "Step series including travelling, change of direction AND a 360° turn",
    dance_step_series_dss_3: "Step series including travelling, change of direction OR a 360° turn",
    dance_step_series_dss_4:
      "Step series including change of rhythm OR combining with another movement family",
    step_series_plus_other: "Step series combined with another movement family",
    acrobatics_acro_move: "Acrobatic movement",
    flexibility_back: "Flexibility, spine",
    flexibility_side_line: "Flexibility, side line",
    flexibility_right: "Flexibility, right",
    flexibility_left: "Flexibility, left",
    flexibility_additional: "Optional flexibility movement (right / left / side / spine)",
    bilaterality_balance_left: "Balance left",
    bilaterality_balance_right: "Balance right",
    bilaterality_jump_left: "Jump left",
    bilaterality_jump_right: "Jump right",
    body_series_1: "1st body series",
    body_series_2: "2nd body series",
    body_series_3: "3rd body series",
  },
  stara: {
    group: {
      body_control: "Body control",
      physical_qualities: "Physical qualities",
      sport_skills: "Sport skills",
      presentation: "Presentation",
      group_assessment: "Group assessment",
    },
    element: {
      posture: "Posture",
      balance: "Balance",
      agility: "Agility",
      core: "Core",
      basic_positions: "Basic positions",
      extensions: "Extensions",
      flexibility: "Flexibility",
      strength: "Strength",
      speed: "Speed",
      endurance: "Endurance",
      technique: "Technique",
      movement_skills: "Movement skills",
      rhythm_tempo: "Rhythm and tempo",
      joy_enthusiasm: "Joy and enthusiasm",
      expression: "Expression",
      memory: "Memory",
      courage: "Courage",
      simultaneity_rhythm: "Simultaneity / rhythm",
      uniform_technique: "Uniform performance technique",
      group_cooperation: "Group cooperation",
      patterns_formations: "Patterns and formations",
      group_contact: "Contact within the group",
    },
    grade: {
      A: "WOW",
      B: "Good",
      C: "Practice",
    },
  },
  dance: {
    T1: {
      perf_presence: "Presence",
      perf_energy: "Energy",
      perf_fluency: "Fluency",
      perf_naturalness: "Naturalness",
      perf_interaction: "Interaction with dancers and/or audience and environment",
      expr_consistency: "Expression sustained throughout choreography",
      expr_alignment: "Expression suits the choreography",
      expr_interpretation:
        "Physical interpretation of movement and choreography suitable for age and skill level",
      expr_impact: "Choreography moves/touches",
      overall_value: "Performance as a whole",
    },
    T2: {
      tech_mastery: "Mastery of style-specific dance technique",
      tech_authenticity:
        "Execution and application of dance technique and culture used in the piece",
      tech_precision: "Precision, well-rehearsed, synchronized, polished, confident execution",
      tech_dynamics: "Application of dynamics",
      tech_timing: "Rhythm, teamwork, timing",
      tech_flow: "Breath and flow",
      phys_control: "Body control",
      phys_agility: "Agility",
      phys_strength: "Strength",
      phys_balance: "Balance",
      phys_flexibility: "Flexibility",
      phys_endurance: "Endurance",
      safety_value: "Safety (lifts, jumps, acrobatics, body control)",
      overall_value: "Performance as a whole",
    },
    T3: {
      chor_creativity: "Creativity and originality",
      chor_appropriateness:
        "Ethics and appropriateness of choreography and theme for age and skill level",
      chor_music: "Music appropriateness for age and skill level",
      chor_styling: "Costumes, makeup, and props designed as a coherent whole according to theme",
      chor_continuity: "Combining movements and movement sequences into a whole",
      chor_suitability:
        "Suitability of movement choices for the group's skill level and physical attributes",
      chor_interpretation: "Movement choices in relation to the chosen theme",
      chor_spacing: "Use of performance area, patterns, levels, directions, and transitions",
      chor_musicality: "Utilization of music in choreography",
      chor_overall: "Performance as a whole",
    },
    T: {
      idea_creativity: "Creativity and originality",
      idea_ethics: "Ethics and appropriateness of choreography and theme for age and skill level",
      idea_music: "Music appropriateness for age and skill level",
      idea_costumes: "Costumes, makeup, and props designed as a coherent whole according to theme",
      comp_combination: "Combining movements and movement sequences into a whole",
      comp_suitability:
        "Suitability of movement choices for the group's skill level and physical qualities",
      comp_theme: "Movement choices in relation to the chosen theme",
      comp_space: "Use of performance area, patterns, levels, directions, and transitions",
      comp_music: "Utilization of music in choreography",
      overall_unity: "The work as a whole",
    },
  },
  gfl: {
    T: {
      value1: "Expressiveness",
      value2: "Innovation and originality",
      value3: "Technique, quality, safety",
      value4: "Overall composition, variety and diversity",
    },
    feedbackTitle: "Strengths and training tips",
  },
  tanvo: {
    T: {
      basic_technique: "Command of the basic technique of dance gymnastics",
      chor_variety: "Diversity and versatility of the choreography",
      exe_confidence: "Confidence and consistency of the performance",
      music_use: "Use of music and its suitability for the chosen movements",
      area_use: "Use of the performance area",
      safety: "Safety and adequacy of the gymnasts' physical qualities",
      value1: "Value 1",
      value2: "Value 2",
      value3: "Value 3",
      value4: "Value 4",
      value5: "Value 5",
      value6: "Value 6",
    },
    CHOR: {
      chor_structure: "Structure of the choreography",
      chor_music: "Combining the movement material with the music, use of music",
      chor_movement_language: "Suitability of the movement language for the choreography",
      chor_dynamics: "Variation of dynamics and tempo in dance gymnastics movements and sequences",
      chor_space: "Use of the performance area, patterns, levels, directions and transitions",
      chor_difficulty:
        "Suitability of the difficulty of the movements and of the choreography for the team",
      chor_originality: "Impact, originality and inventiveness of the choreography",
      chor_interaction: "Effectiveness of the interaction",
      chor_overall: "The choreography as a whole",
      value1: "Value 1",
      value2: "Value 2",
      value3: "Value 3",
      value4: "Value 4",
      value5: "Value 5",
      value6: "Value 6",
      value7: "Value 7",
      value8: "Value 8",
      value9: "Value 9",
    },
    EXE: {
      exe_core_movement:
        "Correct execution of the core-initiated movement characteristic of dance gymnastics",
      exe_precision: "Well-rehearsed, polished and confident performance",
      exe_body_movements: "Command of the body movements of dance gymnastics",
      exe_posture: "Body support and posture",
      exe_foot_technique: "Foot technique",
      exe_arm_technique: "Command of arm movements using dance gymnastics technique",
      exe_formations: "Formation of the patterns",
      exe_safety: "Safety and adequacy of the gymnasts' physical qualities",
      exe_performance: "Performance and expression",
      value1: "Value 1",
      value2: "Value 2",
      value3: "Value 3",
      value4: "Value 4",
      value5: "Value 5",
      value6: "Value 6",
      value7: "Value 7",
      value8: "Value 8",
      value9: "Value 9",
    },
  },
};
